import { gql } from '@efficiently/client-core-graphql-models';

export const UPLOAD_FINISH_DOCUMENTS = gql(`
	mutation ProjectLocationUploadFinishDocuments($args: ContentUploadArgs!) {
		uploadFinishDocuments(args: $args) {
			...FinishDomainFinishToDocumentFields
		}
	}
`);

export const SAVE_FINISH_DOCUMENTS = gql(`
	mutation ProjectLocationSaveFinishDocuments($records: [FinishToDocumentInput!]!) {
		saveFinishDocuments(records: $records) {
			...FinishDomainFinishToDocumentFields
		}
	}
`);

export const DELETE_FINISH_DOCUMENTS = gql(`
	mutation ProjectLocationDeleteFinishDocuments($ids: [String!]!, $finishId: String!) {
		deleteFinishDocuments(ids: $ids, finishId: $finishId) {
			...FinishDomainFinishToDocumentFields
		}
	}
`);
